<script>
export default {
  methods: {
    goToBusinessArea: function() {
      let params = this.$route.params;
      if (params.systemId) {
        this.$router.push({
          name: 'ModulesList',
          params: {
            systemId: params.systemId
          }
        });
      }
    }
  }
}
</script>

<template>
  <div class="navbar-header">
    <a href="javascript:;" v-if="$route.params.systemId">
      <img src="./logo.png"
           alt="SGS DO BRASIL"
           @click="goToBusinessArea()"
           class="padding-top-10px">
    </a>
    <img src="./logo.png" v-else
         alt="SGS DO BRASIL"
         class="padding-top-10px">
  </div>
</template>

<style>
 .padding-top-10px {
    padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// brand.vue?60bce382